import LogIn from './pages/LogIn';
import Recovery from './pages/Recovery';
import Registration from './pages/Registration';
import { AUTH_ROUTE, RECOVERY_ROUTE, REGISTRATION_ROUTE } from './utils/consts';

export const publicRoutes = [
    {
        path: AUTH_ROUTE,
        Component: LogIn
    },
    {
        path: REGISTRATION_ROUTE,
        Component: Registration
    },
    {
        path: RECOVERY_ROUTE,
        Component: Recovery
    }
];